module.exports = __webpack_public_path__ + "static/img/05chahua5.54f71ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/zcx/assets/images/05chahua5.png
// module id = +GkV
// module chunks = 7